import { FaExclamationCircle } from "react-icons/fa";

const NoData = () => {
  return (
    <div className="flex flex-col items-center justify-center p-4  my-5">
      <FaExclamationCircle className="text-gray-500 text-xl mb-2" />
      <h3 className="text-sm font-semibold text-gray-700">
        No Data Available Yet.
      </h3>
      <p className="text-gray-500 text-xs">
        The data will be available here as soon as it is created.
      </p>
    </div>
  );
};

export default NoData;
